import { put, select } from 'redux-saga/effects';

import type { SagaIterator } from '@redux-saga/types';

import {
  RESOLVE_BY_ACCEPT_AVAILABILITY,
  RESOLVE_BY_CANCEL_INSERT,
  RESOLVE_BY_REPLACE_ENTRIES,
  ResolveActions,
} from '../actions/conflict';
import { cancelInsert, insertInBetSlip, replaceEntries } from '../actions/entries';
import { selectConflictState } from '../selectors/state';
import { ConflictState } from '../types/conflict';

// ---

function* conflictResolutionPrompt(action: ResolveActions): SagaIterator {
  const conflict: ConflictState = yield select(selectConflictState);

  if (!conflict) {
    console.error('conflictResolutionPrompt -> there is no conflict entry');
    return;
  }

  switch (action.type) {
    case RESOLVE_BY_CANCEL_INSERT:
      yield put(cancelInsert(action.payload.betId));
      break;

    case RESOLVE_BY_REPLACE_ENTRIES:
      yield put(cancelInsert(action.payload.by.bet.entity.id));
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      yield put(replaceEntries(conflict.highlightEntryIds, action.payload.by));
      break;

    case RESOLVE_BY_ACCEPT_AVAILABILITY:
      yield put(insertInBetSlip(action.payload.entry));
      break;
  }

  return action;
}


export default conflictResolutionPrompt;
